export type SacredIconName = "book" | "church" | "columns" | "cross" | "dove" | "keys" | "quill" | "scale" | "scroll" | "seal" | "tablets";

export function SacredIcon({ name, size = 22, className }: { name: SacredIconName; size?: number; className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={className ? `sacred-icon ${className}` : "sacred-icon"}
      data-sacred-icon={name}
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
      xmlns="http://www.w3.org/2000/svg"
    >
      {name === "book" ? <>
        <path d="M5 7.2c4.8-.7 8.6.1 11 2.3 2.4-2.2 6.2-3 11-2.3v16c-4.8-.7-8.6.1-11 2.3-2.4-2.2-6.2-3-11-2.3v-16Z" />
        <path d="M16 9.5v16M8 11c2.3-.1 4.3.2 6 1M18 12c1.7-.8 3.7-1.1 6-1" />
        <path d="M16 2v5m-2.2-2.8h4.4" />
      </> : null}
      {name === "church" ? <>
        <path d="M6 13h20v13H6V13Zm-2 13h24M3.5 13 16 7l12.5 6H3.5ZM12 17v9m8-9v9M16 2v6m-2.5-3.5h5" />
        <path d="M13 26v-5a3 3 0 0 1 6 0v5" />
      </> : null}
      {name === "columns" ? <>
        <path d="M4 9h24L16 4 4 9Zm2 16h20M7 11v12m6-12v12m6-12v12m6-12v12M5 27h22" />
      </> : null}
      {name === "cross" ? <path d="M16 4v24M7 12h18" strokeWidth="2.6" /> : null}
      {name === "dove" ? <>
        <path d="M27 10c-4.5 1.2-7.5.4-10.2-2.7.4 3.7-1.6 5.7-5.3 6.3 2.5 1.1 4.8 1.2 7.1.4-2.2 3.8-6.8 6.5-13.6 8.1 7.8 2.6 15.6-.1 19.1-6.7l3.1 1.2-.2-6.6Z" />
        <path d="m16.8 7.3 3.5-3m-9 12.1 3.3 1.2" />
      </> : null}
      {name === "keys" ? <>
        <circle cx="10" cy="11" r="4.5" />
        <path d="m13.4 14.4 12 12m-5.7-5.7 3-3m-6 0 3-3m-9.7-3.2h.1" />
        <circle cx="22.5" cy="9.5" r="4.5" />
        <path d="m19.4 12.6-6 6m2.9-2.9 3 3" />
      </> : null}
      {name === "quill" ? <>
        <path d="M26 5C17 5.3 9.6 8.8 8.2 16.3c-.5 2.6.7 4.6 3.3 5.1C19 22.7 25.2 15.8 26 5Z" />
        <path d="M5 27c4.5-7 9.3-12.4 16.8-17.5M10 19l.4 4.5m4.4-10.1 4.8.5" />
      </> : null}
      {name === "scale" ? <>
        <path d="M16 5v21M7 27h18M11 8h10M16 5l-2-2m2 2 2-2M7 8l-4 9h8L7 8Zm18 0-4 9h8l-4-9Z" />
        <path d="M3 17c.7 2.3 6.3 2.3 8 0m10 0c.7 2.3 6.3 2.3 8 0" />
      </> : null}
      {name === "scroll" ? <>
        <path d="M8 5h16a3 3 0 0 1 3 3v15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V8a3 3 0 0 1 4-3Z" />
        <path d="M8 5v18m5-12h9m-9 5h9m-9 5h6" />
        <circle cx="8" cy="5" r="2.2" fill="currentColor" />
      </> : null}
      {name === "seal" ? <>
        <path d="m16 3 3.2 3.1 4.5-.2.7 4.4 3.1 3.2-2.3 3.9.8 4.4-4.1 1.7-2 4-4.2-1.4-4.2 1.4-2-4-4.1-1.7.8-4.4-2.3-3.9 3.1-3.2.7-4.4 4.5.2L16 3Z" />
        <path d="M16 10v12m-4-8h8" />
      </> : null}
      {name === "tablets" ? <>
        <path d="M5 6.5A3.5 3.5 0 0 1 8.5 3h6v24H8.5A3.5 3.5 0 0 1 5 23.5v-17ZM18 3h5.5A3.5 3.5 0 0 1 27 6.5v17a3.5 3.5 0 0 1-3.5 3.5H18V3Z" />
        <path d="M9 9h2.5m-2.5 4h2.5m-2.5 4h2.5m7-8h2.5m-2.5 4h2.5m-2.5 4h2.5" />
      </> : null}
    </svg>
  );
}
